import PropTypes from 'prop-types';
import React from 'react';

const RenText = ({ data, accessor, columnData }) => {
  const { secondary = true } = columnData;
  const className = secondary ? 'tbl-ren-text secondary' : 'tbl-ren-text';
  return <div className={className}>{ data[accessor] ? data[accessor] : '-'}</div>;
};

RenText.defaultProps = {
  data: {},
  accessor: '',
  columnData: {},
};

RenText.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape(),
  accessor: PropTypes.string,
  columnData: PropTypes.shape(),
};

export default RenText;
